import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Text,
} from "@chakra-ui/react";
import { CRUD_TYPE_ENUM } from "@root/constants";
import { useTranslation } from "react-i18next";

interface AddSubscriberModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleSubmit: (name: string, email: string) => void;
  selectedSubSubscriber?: any;
  action: CRUD_TYPE_ENUM;
}

export const AddSubscriberModal: React.FC<AddSubscriberModalProps> = ({
  isOpen,
  onClose,
  handleSubmit,
  selectedSubSubscriber,
  action,
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { t } = useTranslation("common");

  useEffect(() => {
    if (action === CRUD_TYPE_ENUM.UPDATE && selectedSubSubscriber) {
      setName(selectedSubSubscriber.fullName || "");
      setEmail(selectedSubSubscriber.email || "");
    } else {
      setName("");
      setEmail("");
    }
    setIsSubmitted(false);
  }, [action, selectedSubSubscriber, isOpen]);

  const onSubmit = () => {
    setIsSubmitted(true);
    if (!name.trim() || !email.trim()) return;
    handleSubmit(name, email);
    onClose();
    setIsSubmitted(false);
  };

  const modalTitle =
    action === CRUD_TYPE_ENUM.UPDATE
      ? "Edit Sub-Subscriber"
      : "Add Sub-Subscriber";

  const buttonLabel =
    action === CRUD_TYPE_ENUM.UPDATE
      ? t("subsubscriberManagement.update")
      : t("subsubscriberManagement.add");

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="white">
        <ModalHeader>{modalTitle}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4} isInvalid={isSubmitted && !name.trim()}>
            <FormLabel>
              {t("subsubscriberManagement.subSubscriberName")}
              <Text as="span" color="red.500" ml={1}>
                *
              </Text>
            </FormLabel>
            <Input
              placeholder={t("subsubscriberManagement.enterSubSubscriberName")}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <FormErrorMessage>
              {t("subsubscriberManagement.nameRequired")}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={isSubmitted && !email.trim()}>
            <FormLabel>
              {t("subsubscriberManagement.email")}
              <Text as="span" color="red.500" ml={1}>
                *
              </Text>
            </FormLabel>
            <Input
              placeholder={t("subsubscriberManagement.enterSubSubscriberEmail")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FormErrorMessage>
              {t("subsubscriberManagement.emailRequired")}
            </FormErrorMessage>
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} variant="outline" onClick={onClose}>
            {t("subsubscriberManagement.cancel")}
          </Button>
          <Button bg="#1819B4" onClick={onSubmit}>
            {buttonLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
